<app-lot-carousel-main-slider
  [lotId]="lot.id"
  [lotType]="lotType"
  [lotSource]="lotSource"
  [media]="allMedia"
  [activeSlideIndex]="activeSlide"
  [isUsingSavedMedia]="isUsingSavedImages"
  (mediaSaved)="mediaChanged.emit()"
  (mediaOrderChanged)="reindexMedia($event)"
  (activeSlideIndexChange)="activeSlideChanged($event)"
></app-lot-carousel-main-slider>

<app-lot-carousel-thumbs
  [media]="regularMedia"
  (activeSlideIndexChanged)="activeSlideChanged($event)"
></app-lot-carousel-thumbs>

<app-lot-carousel-thumbs
  #inspectionThumbs
  *ngIf="!!inspectionMedia.length"
  [media]="displayedInspectionMedia"
  [title]="'AUTO_LOT.GUIDE.LOT_INSPECTION.TITLE' | translate"
  [visibleRowLimit]="2"
  [hasExtraThumb]="isLimited"
  (activeSlideIndexChanged)="activeSlideChanged($event)"
>
  <app-lot-watch-request-buy-button
    [savedLot]="savedLot"
    [lotType]="lotType"
    [lotSource]="lotSource"
    [inspectionData]="inspectionData"
    [fullSize]="true"
  ></app-lot-watch-request-buy-button>

  <app-lot-carousel-thumbs-actions
    [expanded]="inspectionThumbs.expanded"
    [showExpandButton]="inspectionThumbs.showExpandButton"
    (toggleExpand)="inspectionThumbs.toggleExpand()"
    [downloadUrl]="inspectionData?.downloadAllUrl"
  ></app-lot-carousel-thumbs-actions>
</app-lot-carousel-thumbs>
